import styled from '@emotion/styled';

export const Icon = styled.svg<{ fillColor?: string }>`
  fill: ${({ fillColor, theme }) => fillColor || 'currentColor'};
`;
